// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__22HuN","row":"ProcedureTreatmentSummary_row__3PEx3"};